"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextMobile = exports.TextDesktop = void 0;
var _react = _interopRequireWildcard(require("react"));
var _decorators = require("../../decorators");
var _styles = require("./styles");
var _excluded = ["children", "device", "ellipsis", "opacity", "secondary", "size", "tag"]; //helpers
//styled-components
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var TextBase = (0, _decorators.styleable)(function (_ref) {
  var children = _ref.children,
    device = _ref.device,
    ellipsis = _ref.ellipsis,
    opacity = _ref.opacity,
    _ref$secondary = _ref.secondary,
    secondary = _ref$secondary === void 0 ? false : _ref$secondary,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'div' : _ref$tag,
    forwardedProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = _styles.Text.withComponent(tag);
  return /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    ellipsis: ellipsis,
    device: device,
    opacity: opacity,
    secondary: secondary,
    size: size
  }, forwardedProps), children);
});
var TextDesktop = exports.TextDesktop = (0, _decorators.styleable)(function (props) {
  return /*#__PURE__*/_react["default"].createElement(TextBase, _extends({
    device: "desktop"
  }, props));
});
var TextMobile = exports.TextMobile = (0, _decorators.styleable)(function (props) {
  return /*#__PURE__*/_react["default"].createElement(TextBase, _extends({
    device: "mobile"
  }, props));
});
//# sourceMappingURL=index.js.map